import { render, staticRenderFns } from "./jurisdictionForm.vue?vue&type=template&id=92397774&scoped=true&"
import script from "./jurisdictionForm.vue?vue&type=script&lang=js&"
export * from "./jurisdictionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92397774",
  null
  
)

export default component.exports